import {
  TBCTXKeys,
  TBCTXKeysWithoutSize,
  TDefectiveFromServer,
  TDefectiveInfoWithLinkedVId,
  TMultipleRoundsDefectivesListingItemFilter,
  TPaginationInfo,
  TSingleDefectiveEvent,
} from '@monorepo/types';
import { TFilterGroupModel, TUserPaginationOption, UiFilterModifiers } from '@monorepo/ui';
import * as _ from 'lodash';

export const DEFECT_WITH_MULTIPLE_ROUNDS_SELECTION_FILTER_MODEL = {
  createModel: (
    items: TMultipleRoundsDefectivesListingItemFilter[],
    bctxKeysToDisplayMap: Record<TBCTXKeys, string>,
    prevModel?: TFilterGroupModel<TMultipleRoundsDefectivesListingItemFilter>,
  ) => {
    const createNewFilterModel = UiFilterModifiers.createFilterModelList(items, (item) => {
      return {
        type: 'SELECT_FILTER',
        key: item.filterType,
        displayName: bctxKeysToDisplayMap[item.filterType],
        items: item.values.map((val) => {
          return {
            value: val,
            isSelected: false,
          };
        }),
        selectedValues: [],
      };
    });
    return prevModel ? UiFilterModifiers.updateFilterModelList(createNewFilterModel, prevModel) : createNewFilterModel;
  },
  getFilteredDefectList: (
    selectedFilters: TMultipleRoundsDefectivesListingItemFilter[],
    defectList: TDefectiveInfoWithLinkedVId[],
    userPaginationOption: TUserPaginationOption,
    orderKeys: TBCTXKeysWithoutSize[],
  ) => {
    const rangeInPageStart = (userPaginationOption.pageNo - 1) * userPaginationOption.pageSize + 1;
    const rangeInPageEnd = userPaginationOption.pageNo * userPaginationOption.pageSize;
    const filteredDefectList: TDefectiveInfoWithLinkedVId[] = [];
    defectList.forEach((event) => {
      const itemInfo = event.event;
      let isFiltered = true;
      selectedFilters.forEach((selectedFilter) => {
        if (selectedFilter.values.length) {
          isFiltered =
            isFiltered &&
            selectedFilter.values.some((f) =>
              itemInfo.eventInfo.bctxDetails.businessContextDetailsWithoutSize.some(
                (item) => item.k === selectedFilter.filterType && item.v === f,
              ),
            );
        }
      });
      if (isFiltered) filteredDefectList.push({ ...event });
    });
    const supportedFilters: TMultipleRoundsDefectivesListingItemFilter[] = [];
    orderKeys.forEach((key) => {
      supportedFilters.push({
        filterType: key as TMultipleRoundsDefectivesListingItemFilter['filterType'],
        values: _.uniq(
          filteredDefectList.reduce((acc, bctxListItem) => {
            const itemInfo = bctxListItem.event.eventInfo.bctxDetails.businessContextDetailsWithoutSize.find(
              (item) => item.k === key,
            );
            if (itemInfo) acc.push(itemInfo.v);
            return acc;
          }, [] as string[]),
        ),
      });
    });
    const paginatedFilteredBctxList = filteredDefectList.slice(rangeInPageStart - 1, rangeInPageEnd);
    const paginationInfo: TPaginationInfo = {
      itemsPerPage: userPaginationOption.pageSize,
      rangeInPage: {
        start: rangeInPageStart,
        end: rangeInPageEnd,
      },
      totalItems: filteredDefectList.length,
      totalPageCount: DEFECT_WITH_MULTIPLE_ROUNDS_SELECTION_FILTER_MODEL.getTotalPageCount(
        filteredDefectList.length,
        userPaginationOption.pageSize,
      ),
    };
    return {
      paginationInfo,
      supportedFilters,
      paginatedFilteredBctxList,
    };
  },
  getTotalPageCount: (totalItems: number, itemsPerPage: number) => {
    return Math.ceil(totalItems / itemsPerPage);
  },
};
